import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import inquiryListApi from "api/inquiryListApi";
import { formatQueryParams } from "helpers/format";

export const getInquiryList = createAsyncThunk(
  "InquiryList",
  async (params: any = {}) => {
    try {
      const response = await inquiryListApi.inquiries(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getInquiryDetail = async (
  id: string | number,
  params: any = {}
) => {
  try {
    const response = await inquiryListApi.getInquiryDetail(id, params);
    return response;
  } catch (error) {
    return error;
  }
};

export const postInquiryInformation = async (id: any, data: any = {}) => {
  try {
    const response = await inquiryListApi.createInquiry(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
